// API Configuration
// Base URL for all Xano endpoints

export const API_BASE_URL = 'https://x8ki-letl-twmt.n7.xano.io/api:qxx8yw8m';
